import { useSelector } from 'react-redux'
import { DashboardTypes } from 'features/Codes'
import { campaignTableActions } from 'features/dashboard/table/campaign/campaignTableSlice'
import { adGroupTableActions } from 'features/dashboard/table/adGroup/adGroupTableSlice'
import { keywordTableActions } from 'features/dashboard/table/keyword/keywordTableSlice'
import { creativeTableActions } from 'features/dashboard/table/creative/creativeTableSlice'
import { useMemo } from 'react'

const DashboardTableActions = {
  [DashboardTypes.CAMPAIGN]: campaignTableActions,
  [DashboardTypes.AD_GROUP]: adGroupTableActions,
  [DashboardTypes.KEYWORD]: keywordTableActions,
  [DashboardTypes.CREATIVE]: creativeTableActions,
}
export const useDashboardTableActions = type => {
  const { type: tab } = useSelector(state => state.dashboard.common)
  return useMemo(() => DashboardTableActions[type || tab], [type, tab])
}
